import React from "react";
import { Constants } from "../../CommonMethhods/Constants";

function TodateComponent(props) {
  const toDate = props.toDate;
  const formatToDate = props.formatToDate;
  const DateReverse = props.DateReverse;
  const errorResponse = props.errorResponse;
  const calanderIcon = props.clientWiseReportForCustomCalanderIcon;
  const inputWidth = props?.inputWidth;
  const min = props?.minDate;
  const allowFutureDates = props?.allowFutureDates;
 
  return (
    <>
      <div className={ `${allowFutureDates ? "date-customized form-group calendar-icon" : "form-group calendar-icon"}`}>
        <label className="form-label">{Constants.To_Date}<span style={{ color: "red" }}>*</span></label>
        <input
          type="date"
          placeholder="DD/MM/YYYY"
          className={`${inputWidth === "custom" ? "report-custom-select personalised-select" : "datepicker form-control"}`}
          id="ToDateCombine"
          onChange={toDate}
          onInvalid={(e) => {
          e.preventDefault();
          e.target.setCustomValidity("");
        }}
          defaultValue={formatToDate}
          max={allowFutureDates ? "9999-12-31" : DateReverse}
          // {...(!allowFutureDates && { max: DateReverse })}
          {...(allowFutureDates && { min: min })}
        />
        <span className="to-date-error">{errorResponse}</span>
        {calanderIcon && <span className="icon-calendar ico"></span>}
      </div>
    </>
  );
}
export default TodateComponent;
